import { FormArray } from "@angular/forms";

export class ActionApiCongigs {
  uId: string;
  apiendpointtype: string;
  apiendpoint: string;
  aID: string;
  itemRows: FormArray;
  itemRowsH: FormArray;
  itemRowsB: FormArray;
  op1: boolean;
  op2: boolean;
}
